<template>
  <div class="container">
    <div class="content-box">
      <div class="title-img t1"></div>
      <ul class="dec-one">
        <li><i></i><span>领：“立即领取红包”获100/130元红包，可在购买会员卡时抵扣。</span></li>
        <li><i></i><span>送好友：买卡后，即获多个优惠100元红包，转发好友可领。</span></li>
        <li><i></i><span>得佣金：每被好友使用一次，您获佣金50元现金；在下方“我的推广佣金”中提现。</span></li>
        <li><i></i><span>每人可买多张卡（可转让），用多个红包，但每次付款限用一个。</span></li>
      </ul>
      <div class="vedio-box">
        <video v-if="!isShow" width="100%" height="100%" src="https://image.zhiyue.xin/video/WeChat_20190421223722.mp4" preload="auto" controls="controls" poster="/images/li.png"></video>
      </div>
      <h2>跟对的人，读对的书</h2>
      <h3>听万里挑一的人，为你解读万里挑一的书</h3>
      <div class="title-img t2"></div>
      <h4>每人皆是“读万卷书，行万里路，经万件事，抒万丈情”</h4>
      <ul class="teacher-list">
        <li>
          <div class="photo"><img src="../../public/images/1-1.1贾平凹（作家）.jpg" alt=""></div>
          <h5>贾平凹</h5>
          <p>著名作家</p>
          <p>中国作协副主席</p>
        </li>
        <li>
          <div class="photo"><img src="../../public/images/1-1.2钱文忠（学者）.jpg" alt=""></div>
          <h5>钱文忠</h5>
          <p>国学普及第一人</p>
          <p>复旦大学教授</p>
        </li>
        <li>
          <div class="photo"><img src="../../public/images/1-1.3崔永元（主持人）.jpg" alt=""></div>
          <h5>崔永元</h5>
          <p>最有良心的主持人</p>
        </li>
        <li>
          <div class="photo"><img src="../../public/images/1-1.4黄磊（演员）.jpg" alt=""></div>
          <h5>黄磊</h5>
          <p>影视演员</p>
          <p>导演</p>
        </li>
        <li>
          <div class="photo"><img src="../../public/images/1-1.5戴军（主持人）.jpg" alt=""></div>
          <h5>戴军</h5>
          <p>多栖艺人</p>
          <p>情感作家、投资人</p>
        </li>
        <li>
          <div class="photo"><img src="../../public/images/1-2.1刘同（作家）.jpg" alt=""></div>
          <h5>刘同</h5>
          <p>"迷茫"三部曲超级</p>
          <p>畅销书作家</p>
          <p>光线影业副总裁</p>
        </li>
        <li>
          <div class="photo"><img src="../../public/images/1-2.2俞敏洪（新东方）.jpg" alt=""></div>
          <h5>俞敏洪</h5>
          <p>新东方总裁</p>
        </li>
        <li>
          <div class="photo"><img src="../../public/images/1-2.3周鸿祎（360创始人）.jpg" alt=""></div>
          <h5>周鸿祎</h5>
          <p>奇虎360总裁</p>
        </li>
        <li>
          <div class="photo"><img src="../../public/images/1-2.4吴晓波（财经作家）.jpg" alt=""></div>
          <h5>吴晓波</h5>
          <p>企业家</p>
          <p>最有品牌价值的财经作家</p>
        </li>
        <li>
          <div class="photo"><img src="../../public/images/1-2.5于丹（文化学者）.jpg" alt=""></div>
          <h5>于丹</h5>
          <p>文化学者</p>
          <p>最有温度的思想传播者</p>
        </li>
      </ul>
      <dl class="dec-two">
        <dt>更多讲师：</dt>
        <dd><i></i><b>周国平</b>（著作最多、销量最广、唯一在世的思想家之一）、<b>熊召政</b>（历史学家、湖北省文联主席、《张居正》作者）、<b>纪连海</b>（历史奇才、《百家讲坛》金牌主讲）、<b>张颐武</b>（北大教授）、<b>顾及</b>（斯坦福学霸、创业教育家）、<b>李永乐</b>（网红数理教师，科普达人）、<b>李柘远</b>（哈佛学霸、国民学长）</dd>
        <dd><i></i><b>麦家</b>（谍战作家、编剧、茅盾文学奖主）、<b>苏芩</b>（微博粉丝过5000万的情感作家、“新女学”倡导者）、<b>洪晃</b>（时尚教母、名门才女、国际名主编、博客点击过亿）、<b>张嘉佳</b>（畅销书、同名电影《从你的全世界路过》作者、导演）、<b>廖一梅</b>（编剧、作家、代表作《恋爱的犀牛》）、<b>大冰</b>（佛系畅销书《好吗好的》作者）、<b>江南</b>（超一线幻想小说家）</dd>
        <dd><i></i><b>张泉灵</b>（前央视主持人）、<b>孟京辉</b>（先锋导演）、<b>喻恩泰</b>（学历最高的著名演员）、<b>蒋昌建</b>（《最强大脑》主持人、耶鲁大学博士、复旦大学教授）、<b>张绍刚</b>（主持人、中国传媒大学教授）、<b>李响</b>（著名主持人）、 <b>马薇薇</b>（主持人、奇葩之王）、<b>艾弥儿</b>（最火的情感短视频红人、两性专家）</dd>
        <dd><i></i><b>曹景行</b>（资深媒体人  曾凤凰卫视副台长）、<b>刘亚东</b>（《科技日报》总编辑）、<b>马川</b>（知名媒体人）、<b>韩国辉</b>（曾旅游卫视台长、最年轻的掌门人）、<b>侯小强</b>（前盛大文学CEO、新浪副总编）、<b>李岱</b>（亚洲知名媒体人， Zebra Media 创始人）、<b>冯仑</b>（企业家、思想家）、<b>李国庆</b>（当当网创始人、早晚读书创始人、企业家）</dd>
      </dl>
      <div class="title-img t3"></div>
      <ul class="book-list">
        <li>
          <div class="book-pic"><img src="../../public/images/1.别做那只迷途的候鸟（刘同.jpg" alt=""></div>
          <p>别做那只迷途的候鸟</p>
          <p>刘同解读</p>
        </li>
        <li>
          <div class="book-pic"><img src="../../public/images/2.卓有成效的管理者（李国庆）.jpg" alt=""></div>
          <p>卓有成效的管理者</p>
          <p>李国庆解读</p>
        </li>
        <li>
          <div class="book-pic"><img src="../../public/images/3.去你的脂肪（戴军.jpg" alt=""></div>
          <p>去你的脂肪</p>
          <p>戴军解读</p>
        </li>
        <li>
          <div class="book-pic"><img src="../../public/images/4.金赛性学报告（艾弥儿）.jpg" alt=""></div>
          <p>金赛性学报告</p>
          <p>艾弥儿解读</p>
        </li>
      </ul>
      <ul class="book-list">
        <li>
          <div class="book-pic"><img src="../../public/images/5.高效能人士的七个习惯（李柘远）.jpg" alt=""></div>
          <p>高效能人士的七个习惯</p>
          <p>李柘远解读</p>
        </li>
        <li>
          <div class="book-pic"><img src="../../public/images/6.生活的艺术（于丹）.jpg" alt=""></div>
          <p>生活的艺术</p>
          <p>于丹解读</p>
        </li>
        <li>
          <div class="book-pic"><img src="../../public/images/7.做哲学（周国平）.jpg" alt=""></div>
          <p>做哲学</p>
          <p>周国平解读</p>
        </li>
        <li>
          <div class="book-pic"><img src="../../public/images/8.我想成为的女人（洪晃）.jpg" alt=""></div>
          <p>我想成为的女人</p>
          <p>洪晃解读</p>
        </li>
      </ul>
    </div>
    <!-- <ul class="btn-fix">
      <li @click="myInvitation">我的推广佣金</li>
      <li @click="getRedpacket">立即领取红包</li>
    </ul> -->
    <loginbox :isShow="isShow" @closeFn="closeFn" :isPath="isPath"></loginbox>
    <div class="mask" @click="closeFn(false)" v-show="isShow"></div>
  </div>
</template>

<script>
import Loginbox from '@/components/login-box'
import wx from "weixin-js-sdk"
import Swiper from "swiper"
import'../../node_modules/swiper/dist/css/swiper.css'
export default {
  name: "card",
  data() {
    return{
      isShow: false,
      isPath: true,
      shareUrl: ''
    }
  },
  created() {
    this.$loading.show({
      el: this.$refs.loading
    })
    // 获取用户openid
    let wxopenid = localStorage.getItem('wxopenid') ? localStorage.getItem('wxopenid') : ''
    let authType = localStorage.getItem('authType') ? localStorage.getItem('authType') : ''
    let uid = localStorage.getItem('uid') ? localStorage.getItem('uid') : ''
    let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
    console.log(111, wxopenid)
    console.log(111, authType)
    console.log(111, uid)
    console.log(111, token)
    let access_code = this.GetQueryString('code')
    if (!uid && !token) {
      if (!wxopenid){
        if (!access_code) {
            let fromurl = location.href
            var url='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0764a0a7bdc21d2c&redirect_uri='+encodeURIComponent(fromurl)+'&response_type=code&scope=snsapi_userinfo&state=STATE%23wechat_redirect&connect_redirect=1#wechat_redirect'
            location.href = url
        } else {
          this.axiosPost('auth/token',{ // 用code请求接口获取openid
            code: access_code,
            authType: 2,
            equipmentNo: 'asdzxc',
            equipmentModel: 'asdzxc',
            equipmentSysVersion: 'asdzxc'
          }).then((res) => {
            let authIdNew = res.data.attachment.authId
            if (authIdNew) {
              localStorage.setItem('wxopenid', authIdNew)
            }
            let authTypeNew = res.data.attachment.authType
            if (authTypeNew) {
              localStorage.setItem('authType', authTypeNew)
            }
            let uidNew = res.data.attachment.uid;
            if (uidNew) {
              localStorage.setItem('uid', uidNew)
            }
            let tokenNew = res.data.attachment.token;
            if (tokenNew) {
              localStorage.setItem('token', tokenNew)
            }
          })
        }
      }
    }
    // 分享
    this.shareUrl = `${window.location.protocol}//${window.location.host}/index`
    let isUa = navigator.userAgent.toLowerCase().indexOf("android ") === -1 ? window.location.href : window.location.href 
    if(sessionStorage.getItem('tempUrl')){
      isUa = sessionStorage.getItem('tempUrl')
      sessionStorage.clear()
    }
    this.getShareInfo(isUa)
  },
  mounted() {
  },
  methods: {
    getShareInfo(url) {
      let that = this

      this.axiosPost("act/toShare", {
        // 通过分享接口获取分享url
        appUrl: window.location.href,
        token: localStorage.getItem('token') === null ? '' : localStorage.getItem('token'),
        uid: localStorage.getItem('uid') === null ? 0 : localStorage.getItem('uid')
      }).then(res => {
        this.$loading.hide();
        this.wechatShare = res.data.attachment.wechatShare

        this.axiosPost("wechat/jsconfig", {
          // 微信jsapi-config参数获取
          appUrl: url
        }).then(result => {
          this.$loading.hide();
          let infoTotal = result.data.attachment;
          wx.config({
            debug: false,
            appId: infoTotal.appId,
            timestamp: infoTotal.timestamp,
            nonceStr: infoTotal.nonceStr,
            signature: infoTotal.signature,
            jsApiList: [
            "chooseImage",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ"
              // 所有要调用的 API 都要加到这个列表中
            ]
          })
          wx.ready( () => {
            //分享给好友
            wx.onMenuShareAppMessage({
              title: that.wechatShare.title, // 分享标题
              desc: that.wechatShare.desc, // 分享描述
              link: that.wechatShare.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: that.wechatShare.imgUrl, // 自定义图标
              // title: '1早晚读书送你百元红包，邀你跟对的人，读对的书！', // 分享标题
              // desc: '手快有，手慢无！', // 分享描述
              // link: 'http://h5.wenqitianxia.com?result=Q3RPBVDB5HHP22KAW6LGN3FCNDSPPPUFEUQ3CL7PMZWG7O53ULQQ', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              // imgUrl: 'https://cs-zwds-image.oss-cn-beijing.aliyuncs.com/config_image/bj.png', // 自定义图标
              type: "link", // 分享类型,music、video或link，不填默认为link
              dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
              success: function() {
                //console.log(window.wechatInfo.title)
                // 用户确认分享后执行的回调函数
              },
              cancel: function() {
                // 用户取消分享后执行的回调函数
              }
            })

            //分享朋友圈
            wx.onMenuShareTimeline({
              title: that.wechatShare.title,
              link: that.wechatShare.link,
              imgUrl: that.wechatShare.imgUrl, // 自定义图标
              // title: '1早晚读书送你百元红包，邀你跟对的人，读对的书！',
              // link: 'http://h5.wenqitianxia.com?result=Q3RPBVDB5HHP22KAW6LGN3FCNDSPPPUFEUQ3CL7PMZWG7O53ULQQ',
              // imgUrl: 'https://cs-zwds-image.oss-cn-beijing.aliyuncs.com/config_image/bj.png',// 自定义图标
              trigger: function(res) {
                // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回.
                //alert('click shared');
              },
              success: function(res) {
                //alert('shared success');
                //some thing you should do
              },
              cancel: function(res) {
                //alert('shared cancle');
              },
              fail: function(res) {
                //alert(JSON.stringify(res));
              }
            })
          })
          wx.error(function(res) {
            if(sessionStorage.getItem('tempUrl')){
              return
            }
            sessionStorage.setItem('tempUrl', window.location.href)
            // window.location.reload()
          })
        })
      })
    },
    myInvitation(){ // 我的邀请
      if(localStorage.getItem('uid') && localStorage.getItem('token')){
        let resultid = this.GetQueryString('result')
        this.$router.push({path: '/tgplan', query: {result:resultid}})
      }else{
        this.isShow = true
        this.isPath = false
      } 
    },
    getRedpacket(){ // 领取红包
      if(localStorage.getItem('uid') && localStorage.getItem('token')){
        let resultid = this.GetQueryString('result')
        this.$router.push({path: '/redpacket', query: {result:resultid}})
      }else{
        this.isShow = true
      }
    },
    closeFn(b){
      this.isShow = b
    },
    GetQueryString (name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)")
      let r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2]); return ''
    }
  },
  components: {
    Loginbox
  }
};
</script>


<style lang="stylus" scoped>
*{
  box-sizing:border-box;
  margin 0
}
html {
    height: 100%;
}
body {
    min-height: 100%;
    display: flex;
    flex-direction: column;
}
.container
  width 100%
  background #77D5D7 url('/images/biaoti.png') no-repeat
  background-size 100% auto
  position relative
  padding 2.72rem 0 0.6rem
.content-box{
  flex: 1;
  width:6.7rem;
  height 41.5rem;
  background:rgba(255,255,255,1);
  border-radius:.3rem;
  padding .44rem .44rem 0;
  margin: 0 auto;
}
.title-img{
  height .5rem;
  margin: 0 auto;
}
.dec-one{
  width 100%
  font-size .3rem
  color #333
  margin-top .3rem
}
.dec-one li{
  line-height .42rem
  text-align left
  overflow hidden
  font-family PingFangSC-Regular
  margin-bottom .1rem
}
.dec-one li i{
  background url('/images/circle.png') no-repeat
  background-size 100% auto
  width .18rem
  height .18rem
  margin-right .12rem
  display block
  float left
  margin-top .1rem
}
.dec-one li span{
  width 5.5rem
  display block
  float right
}
.vedio-box{
  width 100%
  height 3.43rem
  margin-top .45rem
  background #000
}
h2{
  font-size:.36rem;
  font-family:STSongti-SC-Black;
  font-weight:900;
  color:rgba(51,51,51,1);
  line-height:.5rem;
  margin: .27rem auto .1rem;
}
h3{
  font-size:.24rem;
  font-family:STSongti-SC-Black;
  font-weight:900;
  color:rgba(51,51,51,1);
  line-height:.33rem;
  margin: .1rem auto .63rem;
}
h4{
  font-size:.24rem;
  font-family:STSongti-SC-Black;
  font-weight:900;
  color:rgba(51,51,51,1);
  line-height:.33rem;
  margin: .2rem auto .5rem;
}
.teacher-list{
  width 100%
  overflow hidden
}
.teacher-list li{
  width 50%
  height 1.1rem
  float left
  margin-bottom .4rem
  text-align left
}
.teacher-list li .photo{
  width 1.1rem
  height 1.1rem
  background rgba(216,216,216,1)
  border-radius 50%
  margin-right .12rem
  float left
}
.teacher-list li .photo img{
  width 100%
  height 100%
  border-radius 50%
}
.teacher-list li h5{
  font-size:.28rem;
  font-family:PingFang-SC-Bold;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height:.4rem;
  margin-bottom:.05rem;
}
.teacher-list li p{
  font-size:.2rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:.3rem;
}
.dec-two{
  width 100%
  text-align left 
}
.dec-two dt{
  font-size:.32rem;
  font-family:PingFang-SC-Bold;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height:.45rem;
  margin-bottom: .2rem;
  margin-top: .4rem;
}
.dec-two dd{
  font-size:.28rem;
  font-family:PingFang-SC-Bold;
  color:rgba(0,0,0,1);
  line-height:.4rem;
}
.dec-two dd i{
  background url('/images/circle.png') no-repeat
  background-size 100% auto
  width .18rem
  height .18rem
  margin-right .12rem
  display block
  float left
  margin-top .1rem
}
.book-list{
  width 100%
  display flex
  justify-content space-between
  margin-bottom .48rem
}
.book-list li{
  width 1.35rem
}
.book-list li .book-pic{
  width 1.35rem
  height 1.8rem
  background rgba(216,216,216,1)
  border-radius .1rem
}
.book-list li .book-pic img{
  width 100%
  height 100%
}
.book-list li p:nth-of-type(1){
  font-size:.24rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(51,51,51,1);
  height: .66rem;
  line-height:.33rem;
  text-align: center;
  margin: .1rem auto;
}
.book-list li p:nth-of-type(2){
  font-size:.2rem;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:.28rem;
  text-align: center;
}
.t1
  width 3rem
  background url('/images/t1.png') no-repeat
  background-size 100% auto
.t2
  width 3rem
  background url('/images/t2.png') no-repeat
  background-size 100% auto
.t3
  width 3.42rem
  background url('/images/t3.png') no-repeat
  background-size 100% auto
  margin .8rem auto .45rem
.btn-fix{
  width: 100%;
  height:1.08rem;
  line-height: 1.08rem;
  position:fixed;
  left:0;
  bottom: -.01rem;
  z-index: 9999;
}
.btn-fix li{
  width:50%;
  height:1.08rem;
  text-align:center;
  font-size:.36rem;
  float:left;
}
.btn-fix li:nth-of-type(1){
  background #fff;
  color #E81C35;
}
.btn-fix li:nth-of-type(2){
  background:linear-gradient(135deg,rgba(255,70,70,1) 0%,rgba(231,27,52,1) 100%);
  color #fff;
}
.mask
  background rgba(0,0,0,0.5)
  z-index 999
  position fixed
  top 0
  left 0
  bottom 0
  right 0
</style>
